import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Autocomplete,
  TextField,
} from "@mui/material";

export const CustomSelect = ({
  label,
  value,
  onChange,
  options = [],
  multiple = false,
  required = true,
  fullWidth = true,
  disabled = false,
  name,
}) => {
  return (
    <FormControl fullWidth={fullWidth} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        multiple={multiple}
        name={name}
      >
        {!required && !multiple && <MenuItem value="">All {label}</MenuItem>}
        {options?.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const CustomAutocompleteSelect = ({
  label,
  placeholder,
  value,
  onChange,
  options = [],
  multiple = false,
  fullWidth = true,
  disabled = false,
  name,
  loading,
  helperText,
  error,
  sx,
}) => {
  const getValue = () => {
    if (multiple) {
      return options?.filter((opt) => value?.includes(opt.value)) || [];
    }
    return options?.find((opt) => opt.value === value) || null;
  };

  return (
    <Autocomplete
      fullWidth={fullWidth}
      multiple={multiple}
      options={options}
      getOptionLabel={(option) => option?.label || ""}
      value={getValue()}
      disabled={disabled}
      loading={loading}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      onChange={(_, newValue) => {
        if (multiple) {
          onChange(newValue?.map((opt) => opt.value) || []);
        } else {
          onChange(newValue?.value || "");
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant="outlined"
          name={name}
          helperText={helperText}
          error={error}
          sx={{ ...sx }}
        />
      )}
    />
  );
};
